import React, { FC } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { ShareWishlistItemGrid } from './WishlistItems/ShareWishlistItemGrid'
import { SEO } from '@corratech/pylot-seo'
import { NotFound } from '@components/404'
import { useGetSharedWishlist } from './Hooks/use-get-shared-wishlist'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import { useUI } from '@corratech/pylot-ui/context'
import type { Maybe } from '@pylot-data/pylotschema'

import cn from 'classnames'
import s from '@pagestyles/Wishlist.module.scss'

export type Props = {
    share_id: string
}

type ProductVariantData = {
    id: number
    selected_options: Maybe<Maybe<string>[]>
}

export const ShareWishlistView: FC<Props> = ({ share_id }) => {
    const { t } = useTranslation(['wishlist', 'account', 'common'])
    const { LoadingIndicator } = useUI()
    const { sharedList, loading, error } = useGetSharedWishlist(share_id)
    const config = useStoreConfig()
    // const [productVariants, setProductVariants] = useState<
    //     ProductVariantData[]
    // >([])

    const customerName = sharedList?.customer_name.split(',')[0] || ''
    const wishlistName = sharedList?.name
    const listHasNoItems = sharedList?.items.length === 0

    // if (error) {
    //     return <ErrorPage />
    // }

    if (loading) {
        return (
            <div className="mx-auto max-w-xs">
                <LoadingIndicator />
            </div>
        )
    }

    if (!sharedList || error || listHasNoItems) {
        return <NotFound identifier={config.base.route?.cms_no_route!} />
    }

    return (
        <>
            {/* <Head>
                <title>
                    {t('wishlist|Favorites of')}&nbsp;
                    {customerName}
                    {t(' | Casaideas')}
                </title>{' '}
            </Head> */}
            <SEO
                titleOverride={wishlistName}
                descriptionOverride={t(
                    'wishlist|Check out my favorites on Casaideas'
                )}
            />
            <div className={cn(s['share-wishlist-main'])}>
                <div className={s['share-wishlist-container']}>
                    <div className={s['share-wishlist-header']}>
                        <div className={s['share-wishlist-title']}>
                            {t('wishlist|Favorites list of')}&nbsp;
                            {customerName}
                        </div>
                        <div className={s['share-wishlist-subtitle']}>
                            {customerName}&nbsp;
                            {t('wishlist|Shared the wishlist')}&nbsp;
                            <strong>{wishlistName}</strong>
                            {t('wishlist|Check the products and buy them too')}
                        </div>
                    </div>
                    <div className={s['share-wishlist-products']}>
                        {sharedList?.items.length ? (
                            <ShareWishlistItemGrid items={sharedList?.items} />
                        ) : null}
                    </div>
                </div>
            </div>
        </>
    )
}
